module.exports = __webpack_public_path__ + "static/media/jssvg.b4083db2.svg";